import { createAction } from 'lib/action'

// Lifecycle. VoicePanel dispatches INIT on mount and TEARDOWN on unmount, so
// the session only runs inside the main layout.
const INIT = 'VOICE_INIT'
const TEARDOWN = 'VOICE_TEARDOWN'
const SESSION_STARTED = 'VOICE_SESSION_STARTED'
const SESSION_STOPPED = 'VOICE_SESSION_STOPPED' // { reason: unauthorized | notPermitted | error }

// Connectivity
const GATEWAY_STATE = 'VOICE_GATEWAY_STATE' // idle | connecting | connected | retrying
const SIP_STATE = 'VOICE_SIP_STATE' // idle | connecting | registered | retrying | failed

// Presence (gateway /vehicles and presence_update)
const PRESENCE_UPDATE = 'VOICE_PRESENCE_UPDATE'

// Outbound call
const MAKE_CALL = 'VOICE_MAKE_CALL' // UI
const CALL_DIALING = 'VOICE_CALL_DIALING' // saga: INVITE being sent
const CALL_ANSWERED = 'VOICE_CALL_ANSWERED' // saga: vehicle picked up
const HANGUP = 'VOICE_HANGUP' // UI
const CALL_ENDED = 'VOICE_CALL_ENDED' // saga: { cause }

// Microphone
const TOGGLE_MUTE = 'VOICE_TOGGLE_MUTE' // UI
const MUTE_CHANGED = 'VOICE_MUTE_CHANGED' // saga, after SIP applied it

// User-facing notices, rendered by VoiceNotices with the LangContext texts
const NOTIFY = 'VOICE_NOTIFY'

let callSeq = 0
let noticeSeq = 0

const actions = {
  init: () => createAction(INIT),
  teardown: () => createAction(TEARDOWN),
  sessionStarted: () => createAction(SESSION_STARTED),
  sessionStopped: reason => createAction(SESSION_STOPPED, { reason }),

  setGatewayState: state => createAction(GATEWAY_STATE, { state }),
  setSipState: (state, error) =>
    createAction(SIP_STATE, { state, error: error || null }),

  presenceUpdate: vehicles => createAction(PRESENCE_UPDATE, { vehicles }),

  makeCall: vehicle => createAction(MAKE_CALL, { vehicle }),
  callDialing: vehicle =>
    createAction(CALL_DIALING, { vehicle, id: ++callSeq, at: Date.now() }),
  callAnswered: () => createAction(CALL_ANSWERED, { at: Date.now() }),
  hangup: () => createAction(HANGUP),
  callEnded: cause =>
    createAction(CALL_ENDED, { cause: cause || null, at: Date.now() }),

  toggleMute: () => createAction(TOGGLE_MUTE),
  muteChanged: muted => createAction(MUTE_CHANGED, { muted }),

  // level: error | warning | info. key / hintKey are keys of the `v`
  // dictionary section; detail is appended as-is (e.g. a SIP status code).
  notify: (level, key, options = {}) =>
    createAction(NOTIFY, {
      id: ++noticeSeq,
      level,
      key,
      hintKey: options.hintKey || null,
      detail: options.detail || null,
    }),
}

export {
  INIT,
  TEARDOWN,
  SESSION_STARTED,
  SESSION_STOPPED,
  GATEWAY_STATE,
  SIP_STATE,
  PRESENCE_UPDATE,
  MAKE_CALL,
  CALL_DIALING,
  CALL_ANSWERED,
  HANGUP,
  CALL_ENDED,
  TOGGLE_MUTE,
  MUTE_CHANGED,
  NOTIFY,
}
export default actions
